module.exports = __webpack_public_path__ + "img/video-play.681d969d.webp";